import { mockActionsExpect } from '../helpers';
import { buildStripeActions } from '../../subscriptions/Stripe';
export default ((store, api, actions) => {
  const originalActions = buildStripeActions(store, api, actions);
  return mockActionsExpect(originalActions, []);
});